module.exports = __webpack_public_path__ + "static/media/weiss_thumb_even.2bcd24fc.jpg";